'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = template;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _index = require('../style/index');

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function template() {
    var label = null,
        classList = this.compileStyle(_index2.default);

    if (this.props.label) {
        label = _react2.default.createElement(
            'label',
            { className: classList.label },
            this.props.label
        );
    }

    var i = 0,
        len = this.props.count,
        input = [];

    for (i; i < len; i++) {
        var attributes = {
            type: this.props.type,
            className: classList.field,
            maxLength: this.props.maxLength,
            autoComplete: 'off',
            value: this.state[this.id + i] || '',
            placeholder: this.props.placeholder || '',
            key: 'input-' + i,
            onFocus: this._handleFocus,
            onBlur: this._handleBlur,
            onChange: this._handleChange,
            onKeyDown: this._handleKeyDown,
            onPaste: this._handlePaste,
            ref: this._makeInputRef,
            id: this.id + i,
            'data-qa-node': this.props.attribute + '-' + i,
            'data-qa-value': this.state[this.id + i] || ''
        };

        input.push(_react2.default.createElement(
            'div',
            { className: classList.wrapper, key: 'input-wrapper' + i },
            _react2.default.createElement('input', attributes),
            _react2.default.createElement('hr', { className: classList.border }),
            _react2.default.createElement('hr', { className: classList.activeBorder })
        ));
    }

    return _react2.default.createElement(
        'div',
        {
            className: classList.root + ' ' + (this.props.className || ''),
            onMouseEnter: this._handleHover.bind(this),
            onMouseLeave: this._handleRootBlur.bind(this)
        },
        label,
        input
    );
}